import moment from "moment"

export const date = {
    convertTimeZone(date) {
        return moment(date).format("LLL");
    },
}